export type TocLevel = 2 | 3 | 4;

export type TocItem = {
  id: string;
  text: string;
  level: TocLevel;
};

function slugify(text: string): string {
  const s = text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/gi, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return s || 'section';
}

/**
 * Builds a stable TOC from ATX headings (##–####) in document order.
 * Skips lines inside fenced ``` code blocks.
 */
export function buildTocFromMarkdown(markdown: string): TocItem[] {
  const lines = markdown.split(/\r?\n/);
  let inFence = false;
  const slugUseCount = new Map<string, number>();
  const items: TocItem[] = [];

  for (const rawLine of lines) {
    const trimmedLine = rawLine.trim();
    if (/^```/.test(trimmedLine)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;

    const trimmedStart = rawLine.trimStart();
    const m = /^(#{2,4})\s+(.+)$/.exec(trimmedStart);
    if (!m) continue;

    const hashes = m[1].length;
    if (hashes < 2 || hashes > 4) continue;
    const level = hashes as TocLevel;

    let text = m[2].trim();
    text = text.replace(/\s+#+\s*$/, '').replace(/#+$/, '');

    const base = slugify(text);
    const n = (slugUseCount.get(base) || 0) + 1;
    slugUseCount.set(base, n);
    const id = n === 1 ? base : `${base}-${n}`;
    items.push({ id, text, level });
  }

  return items;
}
